import { Box, Image, type SystemStyleObject, type BoxProps } from '@/ui';
import type { HeaderImage } from '../types';
import { HeaderTitle } from './HeaderTitle';

type Props = BoxProps & {
  isSelected: boolean;
  header: HeaderImage;
};

// the border is drawn with a pseudo element so it appears
// inset and allows items without a border to remain flush
// with the search box/container
const border: SystemStyleObject = {
  borderRadius: 'lg',
  borderWidth: '3px',
  borderStyle: 'solid',
  borderColor: 'purple.500',
  content: "''",
  position: 'absolute',
  inset: 0,
};

export const HeaderItem = ({ header, isSelected, ...props }: Props) => {
  const { id, imageBaseUrl } = header;

  return (
    <Box
      _before={isSelected ? border : undefined}
      _hover={{ _before: border }}
      aspectRatio={3000 / 600}
      bg="purple.50"
      borderRadius="lg"
      cursor="pointer"
      flexShrink="0"
      overflow="hidden"
      pos="relative"
      role="button"
      {...props}
    >
      <HeaderTitle id={id} isSelected={isSelected} />
      <Image
        data-src={imageBaseUrl + 'headerpreview'}
        opacity="0"
        transition="opacity 0.2s ease"
      />
    </Box>
  );
};
